import { queryOptions, useQuery } from "@tanstack/react-query";

import { stoppagesAjax } from "../../ajax/StoppagesAjax";
import { ErrorResponse } from "../../DTOs/Common/ErrorResponse";
import { OptionResponse } from "../../DTOs/Common/OptionResponse";
import { StoppageTypeDto } from "../../DTOs/Stoppage/StoppageTypeDto";
import { OptionType } from "../../types/OptionType";
import { vocabularyName } from "../../i18n/vocabulary";

export const stoppageTypesQuery = queryOptions({
  queryKey: ['references', 'stoppageTypes'],
  queryFn: async () => {
    const res = await stoppagesAjax.getStoppageTypes();
    return ErrorResponse.isErrorResponse(res) ? new OptionResponse<StoppageTypeDto>([]) : res;
  },
  staleTime: 5 * 60 * 1000,
});

export type StoppageSubTypeOption = {
  value: number,
  label: string,
  groupColor: string,
  stoppageType: string,
  downtimeTypeId: number,
  isDowntime: boolean
};

export const toSubTypeOptions = (response: OptionResponse<StoppageTypeDto>): StoppageSubTypeOption[] =>
  response.groups.flatMap(group => group.options.map(o => ({
    value: o.key,
    label: o.label,
    groupColor: group.fullObject?.colourHex ?? '',
    stoppageType: group.label,
    downtimeTypeId: group.key,
    isDowntime: group.fullObject?.isDowntime ?? false
  })));

const toTypeOptions = (response: OptionResponse<StoppageTypeDto>): OptionType<number>[] =>
  response.groups.map(group => ({
    value: group.key,
    label: vocabularyName("stoppageTypes", group.label),
    groupColor: group.fullObject?.colourHex ?? '',
  }));

export function useStoppageTypeOptions() {
  const { data, isLoading } = useQuery({ ...stoppageTypesQuery, select: toTypeOptions });

  return { stoppageTypeOptions: data ?? [], isStoppageTypeLoading: isLoading };
}
